module.exports = __webpack_public_path__ + "img/icon_map_water_zaixian.5fb0e57e.svg";